import { isDateFuture } from '../../../../utils/dateFunctions';
import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    getNowDateOrEarlierMessage,
    getNumMaxMessage,
    getNumMinMessage,
    getReqMessage,
    getSelectMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

export const MIN_VALUE = 0.1;
export const MAX_VALUE = 99.9;
export const HEALTH_INCIDENT_LEVEL = 15.0;
export const RANGE_WARNING_CONTENT =
    'Values outside of healthy range, see Contract guidance for Health Incidents.';

export const validate = (newEntry, initialRow, formType) => {
    let newErrors = {};

    if (!newEntry.eventDate) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getReqMessage('Event date') }
        };
    } else if (isDateFuture(newEntry.eventDate)) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (!newEntry.measurementId) {
        newErrors = {
            ...newErrors,
            measurementId: { error: true, message: getSelectMessage('measurement type') }
        };
    }

    if (!newEntry.measurementValue) {
        newErrors = {
            ...newErrors,
            measurementValue: { error: true, message: getReqMessage('Glucose value') }
        };
    } else if (newEntry.measurementValue < MIN_VALUE) {
        newErrors = {
            ...newErrors,
            measurementValue: { error: true, message: getNumMinMessage('Glucose value', MIN_VALUE) }
        };
    } else if (newEntry.measurementValue > MAX_VALUE) {
        newErrors = {
            ...newErrors,
            measurementValue: { error: true, message: getNumMaxMessage('Glucose value', MAX_VALUE) }
        };
    }

    if (formType === 'edit' && Object.keys(newErrors).length < 1) {
        newErrors = checkDiff(newEntry, initialRow);
    }

    return newErrors;
};
